// @flow
import React from 'react'
import { Provider } from 'react-redux'

import RootContainer from './RootContainer'
import ClientContainer from './ClientContainer'
import SuriApi from '../Services/SuriApi'

// types
import type { GlobalState } from '../store/reducers'

type Props = {
  store: GlobalState,
  token: string,
}

export default class AppContainer extends React.Component<Props> {
  shouldComponentUpdate(nextProps) {
    return this.props.activeSettings !== nextProps.activeSettings
  }

  render() {
    const { store, token, isBackOffice } = this.props

    if (token) {
      SuriApi.setHeader('Authorization', `Bearer ${token}`)
    }

    return (
      <Provider store={store}>
        {isBackOffice ? <RootContainer {...this.props} /> : <ClientContainer {...this.props} />}
      </Provider>
    )
  }
}
